export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./studentList.vue?vue&type=template&id=0c6c0472&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/studentList.vue?vue&type=template&id=0c6c0472&scoped=true&
// module id = null
// module chunks = 